import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useActividadesContext } from "../../UmmIACategories/Hook/useActividades";

const FormatoTaller = () => {
  const { promptData, setPromptData } = useActividadesContext();
  const [formatoTaller, setFormatoTaller] = useState("");

  const handleFormatoTaller = (event) => {
    const formatoTaller = event.target.value;
    setFormatoTaller(formatoTaller);

    setPromptData((prevData) => ({
      ...prevData,
      formato_taller: formatoTaller,
    }));
  };

  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mb={3}>
      <Box>
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography
            sx={{
              fontFamily: "montserrat",
              fontSize: "1.25rem",
              fontWeight: "bold",
              color: "#336B87",
            }}
          >
            Formato *
          </Typography>
        </Box>
        <FormLabel sx={{ fontFamily: "montserrat", fontSize: "0.85rem" }}>
          Selecciona el formato del taller: virtual, presencial o híbrido
        </FormLabel>
        <Grid sx={{ display: "flex", flexDirection: "column" }}>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="niveles de desempeño"
              name="formato_evaluacion"
              value={promptData.formato_taller}
              onChange={handleFormatoTaller}
            >
              <FormControlLabel
                value="virtual"
                control={<Radio sx={{ color: "#336B87" }} />}
                label={
                  <Typography
                    sx={{
                      fontFamily: "montserrat",
                      fontSize: "0.8rem",
                      color: "#336B87",
                    }}
                  >
                    Virtual
                  </Typography>
                }
              />
              <FormControlLabel
                value="presencial"
                control={<Radio sx={{ color: "#336B87" }} />}
                label={
                  <Typography
                    sx={{
                      fontFamily: "montserrat",
                      fontSize: "0.8rem",
                      color: "#336B87",
                    }}
                  >
                    Presencial
                  </Typography>
                }
              />
              <FormControlLabel
                value="hibrido"
                control={<Radio sx={{ color: "#336B87" }} />}
                label={
                  <Typography
                    sx={{
                      fontFamily: "montserrat",
                      fontSize: "0.8rem",
                      color: "#336B87",
                    }}
                  >
                    Híbrido
                  </Typography>
                }
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Box>
    </Grid>
  );
};

export default FormatoTaller;
